import style from './RepresentativeList.module.scss';

import { AddFieldButton } from '@components/ActionButtons/AddFieldButton';
import { RightMenu } from '@components/RightMenu';
import { CreateEhrForm } from '@common/CreateEhrForm';

import { RepresentativeCard, RepresentativeCardType } from './RepresentativeCard';
import { EhrPageAttributes } from 'chaika-test-attributes';
import { RepresentativeType } from 'chaika-enums';

export interface RepresentativeListParams {
    cardType: RepresentativeCardType;
}

interface Props extends RepresentativeListParams {
    representativeIds: string[];
    createMode: boolean;
    createEhrMode: boolean;
    onCreateNewEhrClick(): void;
    onCancelCreateEhr(): void;
    onAddClick(): void;
    onCancelCreate(): void;
    onUpdateRepresentativePerson(oldId: string, newId: string): void;
    onCreateRepresentativePerson(representativeId: string, type: RepresentativeType): void;
    onConfirmRepresentative(representativeId: string): void;
    onRemove(representativeId: string): void;
    onRepresentativeTypeChange(representativeId: string, type: RepresentativeType): void;
}

export function RepresentativeList({
    cardType,
    representativeIds = [],
    createMode,
    createEhrMode,
    onCancelCreateEhr,
    onCreateNewEhrClick,
    onAddClick,
    onRemove,
    onCancelCreate,
    onUpdateRepresentativePerson,
    onCreateRepresentativePerson,
    onConfirmRepresentative,
    onRepresentativeTypeChange,
}: Props) {
    return (
        <div className={style.root}>
            {cardType === RepresentativeCardType.Representative && (
                <RightMenu
                    customWidth
                    isShowing={createEhrMode}
                    onClickOutside={onCancelCreateEhr}
                >
                    <CreateEhrForm
                        onCreate={onCancelCreateEhr}
                        onCancelCreate={onCancelCreateEhr}
                    />
                </RightMenu>
            )}
            {representativeIds.map(id => (
                <div
                    className={style.CardWrapper}
                    key={id}
                >
                    <RepresentativeCard
                        cardType={cardType}
                        representativeId={id}
                        onRemove={onRemove}
                        onRepresentativeTypeChange={onRepresentativeTypeChange}
                        onConfirmRepresentative={onConfirmRepresentative}
                        onUpdateRepresentativePerson={onUpdateRepresentativePerson}
                    />
                </div>
            ))}
            {cardType === RepresentativeCardType.Representative && (
                <div className={style.CardWrapper}>
                    {createMode ? (
                        <RepresentativeCard
                            cardType={cardType}
                            createMode
                            onCreateNewEhrClick={onCreateNewEhrClick}
                            representativeId={null}
                            onCancelCreate={onCancelCreate}
                            onRepresentativeTypeChange={onRepresentativeTypeChange}
                            onCreateRepresentativePerson={onCreateRepresentativePerson}
                        />
                    ) : (
                        <AddFieldButton
                            dataTest={EhrPageAttributes.AddRepresentative}
                            onAddClick={onAddClick}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
